// src/pages/PesquisaJurisprudencia/hooks/useIATab.js
import { useState, useCallback } from 'react';
import { API_BASE_URL, PAGINACAO_INICIAL } from '../utils/constants';

const useIATab = ({ onResultados, onPaginacao }) => {
  const [descricaoIA, setDescricaoIA] = useState('');
  const [loadingIA, setLoadingIA] = useState(false);

  const encontrarJurisprudenciaPorIA = useCallback(async () => {
    if (!descricaoIA.trim()) {
      alert('Digite uma descrição para pesquisa');
      return;
    }
    setLoadingIA(true);
    onResultados([]);
    onPaginacao(PAGINACAO_INICIAL);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/jurisprudencia/encontrar-por-caso`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: descricaoIA.trim() })
      });
      if (response.ok) {
        const data = await response.json();
        onResultados(data.data || []);
        onPaginacao(data.pagination || PAGINACAO_INICIAL);
      } else {
        alert('Erro ao realizar pesquisa por IA');
      }
    } catch (e) {
      console.error('Erro na pesquisa por IA:', e);
      alert('Erro ao realizar pesquisa por IA');
    } finally {
      setLoadingIA(false);
    }
  }, [descricaoIA, onResultados, onPaginacao]);

  return {
    descricaoIA,
    setDescricaoIA,
    loadingIA,
    encontrarJurisprudenciaPorIA
  };
};

export default useIATab;